<template>
  <div class="page">
    <div class="form">
      <div>
        <div class="cell-list">
          <div class="cell" @click="openPicker">
            <div class="label">
              退回原因
              <span>*</span>
            </div>
            <div class="content">
              <span :class="{'qingxuanze': reasonItem.name === '请选择'}">{{ reasonItem.name }}</span>
              <van-icon class="arrow" name="arrow" />
            </div>
          </div>
        </div>
        <div class="Audit-opinion">
          <p class="title">
            补充说明
            <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
          </p>
          <van-field
              class="textarea"
              v-model="content"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入"
            />
          <!-- <textarea
            v-model="content"
            class="textarea"
            placeholder="请输入"
            cols="30"
            rows="10"
            maxlength="500"
          ></textarea> -->
          <div class="tip">{{ content.length }}/500</div>
        </div>
      </div>

      <div class="btn" :class="{'btndisable': reasonItem.name === '请选择' || !content}" @click="confirm">确定</div>
    </div>
    <!-- 弹框 -->
    <list
      ref="picker"
      @select="selectItem"
      @close="selectItem"
      :datalist="dataList"
      :header="'选择退回原因'"
    />
    <!-- <div class="btn-box">
      <div class="btn" :class="{'btndisable': reasonItem.name === '请选择' || !content}" @click="confirm">确定</div>
    </div> -->
  </div>
</template>

<script>
    import list from '../components/listPopup';
    import api from '../../../../service/modules/refund';

    export default {
        components: { list },
        data () {
            return {
                content: '',
                reasonItem: {
                    name: '请选择'
                },
                dataList: [],
                flowId: ''
            };
        },
        created () {
            this.flowId = this.$route.query.flowId;
            this.getDictType()
        },
        methods: {
            getDictType () {
                api.getDictType().then(res => {
                    console.log(res)
                    if (res.ret === 0) {
                        if (res.data && res.data.BACK_UP_REASON) {
                            res.data.BACK_UP_REASON.map(i => {
                                this.dataList.push({
                                    name: i.name,
                                    id: i.code
                                })
                            })
                        }
                    } else {
                        this.dataList = []
                    }
                })
            },
            // 点击退回
            confirm () {
                try {
                    if (this.reasonItem.name === '请选择') {
                        return this.$Toast({
                            message: '请选择退回原因'
                        });
                    } else if (!this.content) {
                        return this.$Toast({
                            message: '请填写说明'
                        });
                    }
                    const param = {
                        flowId: this.flowId,
                        backUpReason: this.reasonItem.id,
                        backUpContent: this.content
                    };
                    api.backUp(param).then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: '退回成功'
                            });
                            setTimeout(() => {
                                this.$router.back();
                            }, 1500);
                        } else {
                            this.$Toast({
                                message: res.msg
                            });
                        }
                    });
                } catch (err) {
                    console.log(err);
                }
            },
            openPicker () {
                this.$refs['picker'].init(this.reasonItem);
            },
            selectItem (item) {
                this.reasonItem = item;
            }
        }
    };
</script>
<style lang="less" scoped>
.page {
  .form {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 16px 34px;
    .van-icon-arrow:before {
      font-size: 12px;
    }
    .cell-list {
      margin-bottom: 24px;
      .cell {
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 14px;
          color: #666666;
          span {
            color: red;
            vertical-align: middle;
            margin-left: 2px;
          }
        }
        /deep/.content {
          display: flex;
          align-items: center;
          .van-field__control {
            text-align: right;
          }
          // .van-radio__label {
          //   font-size: 14px;
          //   color: #171a1d;
          // }
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }
          span {
            font-size: 14px;
            color: #171a1d;
          }
          .qingxuanze {
            color: #CCCCCC;
            font-weight: 400;
          }
          .arrow {
            font-size: 1px;
            color: #a3a3a3;
            margin-left: 5px;
          }
        }
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
         .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
    .btn {
      background-color: #37b375;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
      line-height: 48px;
    }
    .btndisable {
      background-color: #9bd9ba;
    }
}
</style>
